import get from 'lodash/get';
import vars from '../../vars';
import {
  MONTHLY_SUBSCRIPTION,
  MONTHLY_SUBSCRIPTION_RENEW_SKU,
  YEARLY_SUBSCRIPTION_RENEW_SKU,
  YEARLY_SUBSCRIPTION,
} from '../../constants/experiments/skus';
import { AUTH_OAUTHPREMIUMFLOW_ENABLED_PARTNERIDSKUS } from '../../constants/experiments/auth';

export function getDefaultSubscribeSkus(config) {
  const yearlySku = get(config, YEARLY_SUBSCRIPTION, vars.get('YEARLY_SKU'));
  const monthlySku = get(config, MONTHLY_SUBSCRIPTION, vars.get('MONTHLY_SKU'));
  // keep order of skus as annual, monthly. See PaymentForm.
  return [yearlySku, monthlySku];
}

export function getDefaultRenewSkus(config) {
  const yearlyRenewSku = get(
    config,
    YEARLY_SUBSCRIPTION_RENEW_SKU,
    vars.get('YEARLY_RENEW_SKU'),
  );
  const monthlyRenewSku = get(
    config,
    MONTHLY_SUBSCRIPTION_RENEW_SKU,
    vars.get('MONTHLY_RENEW_SKU'),
  );

  // keep order of skus as annual, monthly. See AccountSettingsConnector.
  return [yearlyRenewSku, monthlyRenewSku];
}

export function getPartnerSkus(config, partnerId) {
  const configPartnerSkus = get(
    config,
    AUTH_OAUTHPREMIUMFLOW_ENABLED_PARTNERIDSKUS,
  );
  return (
    (configPartnerSkus && JSON.parse(configPartnerSkus)[partnerId]) || null
  );
}
